/**
 * KiaanTabs — the top tab row of the widget.
 *
 * Live (2026-10-23, plan 2026-10-23-kiaan-on-live.md): ✦ Agents · Communications · 🐞 Report a bug.
 * The dev-only tabs (Calendar & meetings, System monitor, Dev mode) are not on live, so an admin
 * gets the same three tabs as everyone else. The DOM must hold no trace of a tab the person may
 * not have (Review Focus 1).
 */
export type KiaanTabKey = 'agents' | 'comms' | 'bug';

export const TAB_KEYS: KiaanTabKey[] = ['agents', 'comms', 'bug'];

export interface KiaanTabsProps {
  active: KiaanTabKey;
  reportBug: boolean;
  onChange: (tab: KiaanTabKey) => void;
}

export function KiaanTabs({ active, reportBug, onChange }: KiaanTabsProps) {
  const tab = (key: KiaanTabKey, label: string) => (
    <button
      key={key}
      type="button"
      role="tab"
      aria-selected={active === key}
      className={`kw-tab${active === key ? ' kw-on' : ''}`}
      onClick={() => onChange(key)}
    >
      {label}
    </button>
  );
  return (
    <div className="kw-tabs" role="tablist" aria-label="Kiaan" data-tour="kiaan-tabs">
      {tab('agents', '✦ Agents')}
      {tab('comms', 'Communications')}
      {reportBug ? tab('bug', '🐞 Report a bug') : null}
    </div>
  );
}
